// extracted by mini-css-extract-plugin
export default {"featureCards":"FeatureCard_featureCards__8eztp","card":"FeatureCard_card__8lArR"};